export default __webpack_public_path__ + "static/MoonCropped-b2708c3a81a05b4e42600762129697b6.svg";